import { v4 as uuidv4 } from 'uuid';
import getEstimateUrl from 'utils/getEstimateUrl';
import { AnswersState } from 'schemas/answerStateSchema';
import { apiInstance } from './api';
import { PromoCodeResult } from './checkPromoCode';

export const postConfigData = ({
  answers,
  email,
  vendor,
  promoCodeDetails,
}: {
  vendor: string | undefined;
  answers: AnswersState | undefined;
  email?: string | undefined; // optional email to send
  promoCodeDetails?: PromoCodeResult;
}) => {
  const configId = uuidv4();
  return apiInstance.post(`/configs`, {
    vendor,
    configId,
    email,
    emailLink: getEstimateUrl(configId),
    promoCodeDetails,
    ...answers,
  });
};
